import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import NavBar from "./navbar";
import Footer from "./footer";

function About() {
  return (
    <div>
      <NavBar />
      <section className="page-content">
        <Container className="px-4">
          <div
            className="main main-content"
            style={{ paddingLeft: "7%", paddingRight: "7%" }}
          >
            <br />
            <h1>
              {" "}
              <p align="left">
                <b>Work Experience</b>
              </p>
            </h1>
            <hr></hr>
            <h3>
              {" "}
              <p align="left">
                <b>Espressif Systems – Software Engineer Intern</b>
              </p>
            </h3>
            <h5>
              {" "}
              <p align="left">Pune, India | Feb 2023 - June 2023</p>
            </h5>
            <p align="left">
              ➢ Worked on ESP Insights backend framework to monitor the health
              of various devices on field. <br />
              ➢ Developed a time-series LSTM Deep Learning model to analyse
              device behaviour and track various metrics. <br />
              ➢ Implemented an open-source tool to automate the process of
              deployment of Tensorflow Lite ML models on ESP chips. <br />
              ➢ Contributed on Espressif’s open-source tflite-micro repository.
            </p>
            <br />
            <h3>
              {" "}
              <p align="left">
                <b>Google Summer of Code @OSGeo</b>
              </p>
            </h3>
            <h5>
              {" "}
              <p align="left">Remote | June 2021 - August 2021</p>
            </h5>
            <p align="left">
              ➢ Developed code for generating 3D scenes from gltF, obj, mtL
              loaders from ThreeJS and Cesium.
              <br />
              ➢ Worked on converting such files to 3D tiles and loading the
              models to Cesium ION dashboard with REST API.
              <br />
              ➢ Generated volumes from container based deployment of the project
              instance using Docker.
              <br />➢ Delivered fully-fledged documentation of the project and a
              virtual presentation
            </p>
            <br />

            <h3>
              {" "}
              <p align="left">
                <b>Stride AI – Natural Language Processing Intern</b>
              </p>
            </h3>
            <h5>
              {" "}
              <p align="left">Bangalore, India | August 2022 - December 2022</p>
            </h5>
            <p align="justify">
              ➢ Performed Entity Extraction for 6 different languages such as English,
              French, Italian, Portuguese, Spanish and German using Named Entity
              Recognition HuggingFace, and spaCy models.
              <br />
              ➢ Used Machine Learning Models to develop and automate the
              Sentiment Analysis feature in the NLU application.
              <br />
              ➢ Assumed ownership over certain components of the project and
              continuously work to improve them.
              <br />➢ Worked with technical team to improve performance and
              quality of the models.
            </p>
            <br />

            <h1>
              {" "}
              <p align="left">
                <b>Research Experience</b>
              </p>
            </h1>
            <hr></hr>
            <h4>
              {" "}
              <p align="left">
                <b>
                  Enhancing Retinal Scan Classification: A Comparative Study of
                  Transfer Learning and Ensemble Techniques
                </b>
              </p>
            </h4>
            
            <h5>
              {" "}
              <p align="left">
                International Journal on Recent and Innovation Trends in Computing and Communication (IJRITCC) · June 8, 2023{" "}
              </p>
            </h5>
            <p align="justify">
              Retinal fundus scans have become an indispensable tool for doctors
              to diagnose multiple ocular diseases simultaneously. In this
              paper, the results of a variety of deep learning models
              (DenseNet-201, ResNet125V2, XceptionNet, EfficientNet-B7,
              MobileNetV2, and EfficientNetV2M) and ensemble learning approaches
              are presented, which can accurately detect 20 common fundus
              diseases by analyzing retinal fundus scan images. The proposed
              model is able to achieve a remarkable accuracy of 96.98% for risk
              classification and 76.92% for multi-disease detection,
              demonstrating its potential for use in clinical settings.
            </p>
            <p align="left">
              <a href="https://doi.org/10.17762/ijritcc.v11i7s.7031">Show Publication</a>
            </p>
                        <br />


            
            <h4>
              {" "}
              <p align="left">
                <b>
                  A Survey on Detection of Ophthalmic Diseases using Applied
                  Deep Learning Techniques
                </b>
              </p>
            </h4>
            <h5>
              {" "}
              <p align="left">
                European Chemical Bulletin (ECB) · July 1, 2023{" "}
              </p>
            </h5>
            <p align="justify">
              This research aims to review and summarise different ophthalmic
              diseases that can be detected using retinal scans and different
              machine-learning and deep-learning approaches that can be used to
              solve the problem of diagnosing diseases using retinal scans. The
              focus is on reviewing machine learning techniques that can be used
              for multi-disease detection and nerve segmentation.
            </p>
            <p align="left">
              <a href="https://www.eurchembull.com/archives/volume-12/issue-10/8577">
                Show Publication
              </a>
            </p>
            <br />

  <h4>
              {" "}
              <p align="left">
                <b>
                  Comparative Study of Machine Learning Algorithms for Breast
                  Cancer Classification
                </b>
              </p>
            </h4>
            <h5>
              {" "}
              <p align="left">International Conference on Intelligent and Cloud Computing (ICICC) · Oct 22, 2022</p>
            </h5>
            <p align="justify">
              This paper focuses on a comparison of multiple machine learning
              models with the use of different filters for the detection of
              breast cancer. Models used in this experiment include Logistic
              Regression, Extreme Gradient Boosting, etc and it is observed that
              the performance of these models significantly improves with the
              implementation of various data manipulation techniques.
            </p>
            <p align="left">
              <a href="https://link.springer.com/chapter/10.1007/978-981-16-9873-6_49">
                Show Publication
              </a>
            </p>
            <br />

            <h4>
              {" "}
              <p align="left">
                <b>
                  Hybrid Approach for Predicting Heart Failure using Machine
                  Learning
                </b>
              </p>
            </h4>
            <h5>
              {" "}
              <p align="left">IEEE Explore Digital Library · Nov 9, 2021</p>
            </h5>
            <p align="justify">
              The research aims at the prediction of heart failure using
              different machine learning algorithms and hybrid fusion techniques
              like majority voting of the best performing classifiers. This
              paper focuses on a majority based algorithm that uses the 3 best
              performing machine learning models out of the 10 selected
              classification-based machine learning models.
            </p>
            <p align="left">
              <a href="https://ieeexplore.ieee.org/document/9587466">
                Show Publication
              </a>
            </p>
            <br />

          
          </div>
        </Container>
      </section>
      <Footer />
    </div>
  );
}

export default About;
